export default (callback: () => void, test: boolean): void => {
  const existingScript = document.getElementById('connectClient');

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = `/lib/connect-client-${test ? 'production' : 'development'}.js`;
    script.type = 'text/javascript';
    script.id = 'connectClient';

    document.body.appendChild(script);

    script.onload = callback;
  } else {
    callback();
  }
};
